// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { CategoryListResponse } from '@par/app/core/model/dictionaries.response';

export const getCategoryListRequested = createAction('[SELECT CATEGORY] Get Category List Requested');
export const getCategoryListSucceeded = createAction('[SELECT CATEGORY] Get Category List Succeeded', props<{
  response: CategoryListResponse
}>());
export const getCategoryListFailed = createAction('[SELECT CATEGORY] Get Category List Failed');
